<template>
    <div style="width:100%;height:100%">
        <div id="container"></div>
        <div style="
              position: absolute;
              z-index: 100;
              width: 30%;
              display: flex;
              left: 4%;
              top: 3%;        ">
            <el-select v-model="value" class="m-2" placeholder="请选择车辆" size="large" filterable @change="v_details()">
                <el-option v-for="item in options" :key="item.value" :label="item.label" :value="item.value" />
            </el-select>
            <div style="margin-left: 2%;"></div>
            <!-- <el-button type="primary" @click="go_home()">
                <el-icon style="vertical-align: middle">
                    <House />
                </el-icon>
                <span style="vertical-align: middle"> 主页 </span>
            </el-button> -->
            <el-button type="primary">
                <el-icon style="vertical-align: middle">
                    <HelpFilled />
                </el-icon>
                <span style="vertical-align: middle" v-if="isShow" @click="hideLayer"> 切换地图 </span>
                <span style="vertical-align: middle" v-else @click="showLayer"> 切换地图 </span>
            </el-button>
        </div>
    </div>
</template>
<script>
let ditu = null;
let marker = null;
// import { Edit } from "@element-plus/icons";
import { ElMessage, ElMessageBox } from 'element-plus'
import { Search, Close, House, HelpFilled } from '@element-plus/icons-vue'
import { useRouter } from "vue-router";
import { vehicle_drop_down_list, vehicle_details } from '../../api/net_con/net_con';
import { reactive, onMounted, toRefs, ref, onBeforeUnmount } from "vue";
export default {
    name: "Net_connection",
    components: {
        Search,
        Close,
        House,
        HelpFilled
    },
    setup() {
        const data = reactive({
            value: '',
            isShow: true,
            size: 30,
            options: ''
        });
        const router = useRouter();
        const satellite = new AMap.TileLayer.Satellite();
        const v_drop_down_list = () => {
            vehicle_drop_down_list().then((res) => {
                data.options = res.data
            })
        }
        v_drop_down_list()
        const v_details = () => {
            vehicle_details(data.value).then((res) => {
                if (res.data == null) {
                    ElMessage({
                        message: res.message,
                        type: 'error',
                    })
                } else {
                    ElMessage({
                        message: res.message,
                        type: 'success',
                    })
                    if (marker) {
                        ditu.remove(marker);
                    }
                    let lnglat = [res.data.longitude, res.data.latitude];
                    let type = res.data.gps_type;
                   // let course = Number(res.data.course)+90      
                    let course = Number(res.data.course)                                              
                    AMap.convertFrom(lnglat, type, function (status, result) {
                        if (result.info === 'ok') {
                            var resLnglat = result.locations[0];
                            var startIcon = new AMap.Icon({
                                image:  res.data.image_url,
                                // 图标所用图片大小
                                imageSize: new AMap.Size(30, 50),
                            });
                            marker = new AMap.Marker({
                                icon: startIcon,
                                position: resLnglat,
                                offset: new AMap.Pixel(-13, -30),
                                angle: course,
                            });
                            ditu.setCenter(resLnglat);
                            marker.setMap(ditu);
                        }

                    });
                }

            })
        }

        onMounted(() => {
            ditu = new AMap.Map('container', {
                viewMode: '3D', // 默认使用 2D 模式，如果希望使用带有俯仰角的 3D 模式，请设置 viewMode: '3D',
                zoom: 15, //初始化地图层级
                center: [118.176058, 36.905151],
            });
            ditu.add(satellite);
        })

        const go_home = () => {
            localStorage.setItem("selectTab_item", "./Monitor");
            router.push("./Monitor");
        }

        function showLayer() {
            data.isShow = !data.isShow
            satellite.show();
        }

        function hideLayer() {
            data.isShow = !data.isShow
            satellite.hide();
        }

        onBeforeUnmount(() => {
            ditu && ditu.destroy();
        })
        return { ...toRefs(data), showLayer, hideLayer, go_home, v_details };
    },
};
</script>
<style lang="scss" scoped>
.red {
    background-color: brown;
}

#container {
    width: 100%;
    height: 100%;
}
</style>